class Accordion {
    constructor() {
        const accordionButtons = document.querySelectorAll('.js-accordion-trigger');

        accordionButtons.forEach((button, i) => {
            const content = button.nextElementSibling;
            if (!content) {
                return;
            }

            const panelId = content.id || `accordion-panel-${i}`;
            const buttonId = button.id || `accordion-button-${i}`;
            const usesHidden = content.hasAttribute('hidden');

            if (button.tagName !== 'BUTTON') {
                button.setAttribute('role', 'button');
            }
            button.setAttribute('aria-expanded', 'false');
            button.setAttribute('aria-controls', panelId);
            button.id = buttonId;

            content.id = panelId;
            content.setAttribute('role', 'region');
            content.setAttribute('aria-labelledby', buttonId);
            content.classList.remove('accordion--is-expanded');

            this.setTabbable(content, false);

            const toggle = () => {
                const isExpanded = button.getAttribute('aria-expanded') === 'true';
                button.setAttribute('aria-expanded', String(!isExpanded));
                button.classList.toggle('accordion--is-active');
                if (usesHidden) {
                    content.toggleAttribute('hidden', isExpanded);
                } else {
                    content.classList.toggle('accordion--is-expanded');
                }
                this.setTabbable(content, !isExpanded);
            };

            button.addEventListener('click', toggle);

            if (button.tagName !== 'BUTTON') {
                button.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        toggle();
                    }
                });
            }
        });
    }

    setTabbable(container, enable) {
        const focusable = container.querySelectorAll('a, button, input, select, textarea, [tabindex]');
        focusable.forEach(el => {
            if (enable) {
                el.removeAttribute('tabindex');
            } else {
                el.setAttribute('tabindex', '-1');
            }
        });
    }
}

export default Accordion;
